import { AuthLoginErrorModal } from "../components/GlobalModals/AuthLoginErrorModal";
import { ViewScheduleModal } from "../components/GlobalModals/ViewScheduleModal";
import { CheckoutErrorModal } from "../../feature/PurchaseFlow/CheckoutErrorModal";
import { CreateGroupConfirmModal } from "../components/GlobalModals/CreateGroupConfirmModal";
import { RemoveGroupMemberConfirmModal } from "../components/GlobalModals/RemoveGroupMemberConfirmModal";
import { LeaveGroupConfirmModal } from "../components/GlobalModals/LeaveGroupConfirmModal";
import { CancelSubscriptionModal } from "../components/GlobalModals/CancelSubscriptionModal";
import { AnotherGroupWarningModal } from "../components/GlobalModals/AnotherGroupWarningModal";
import { PassPurchaseModal } from "../components/GlobalModals/PassPurchaseModal";
import { ViewEventsModal } from "../components/GlobalModals/ViewEventsModal";
import { AddOnCheckoutErrorModal } from "../components/GlobalModals/AddOnCheckoutErrorModal";
import { ManageCartErrorModal } from "../../feature/PurchaseFlow/ManageCartErrorModal";
import { UpdateProfileModal } from "../components/GlobalModals/UpdateProfileModal";
import { PrePurchaseFAQModal } from "../components/GlobalModals/PrePurchaseFAQModal";
import { BallparkJoinGroupNoPassErrorModal } from "../components/GlobalModals/BallparkJoinGroupNoPassErrorModal";
import { PassErrorMessageModal } from "src/components/feature/PurchaseFlow/PassErrorMessageModal";
import { GenericModal } from "../components/GenericModal";
import { EventAttendanceModal } from "src/components/feature/homepageFlow/event-attendance/EventAttendanceModal";
import { ExchangeReservationModal } from "src/components/feature/homepageFlow/event-attendance/ExchangeReservationModal";
import { SeatLocationsModal } from "../components/GlobalModals/SeatLocationsModal";

export function GlobalModalsProvider() {
  return (
    <>
      <AuthLoginErrorModal />
      <CheckoutErrorModal />
      <ViewScheduleModal />
      <CreateGroupConfirmModal />
      <CancelSubscriptionModal />
      <ViewEventsModal />
      <RemoveGroupMemberConfirmModal />
      <LeaveGroupConfirmModal />
      <AnotherGroupWarningModal />
      <PassPurchaseModal />
      <EventAttendanceModal />
      <ExchangeReservationModal />
      <AddOnCheckoutErrorModal />
      <PassErrorMessageModal />
      <ManageCartErrorModal />
      <UpdateProfileModal />
      <PrePurchaseFAQModal />
      <BallparkJoinGroupNoPassErrorModal />
      <GenericModal />
      <SeatLocationsModal />
    </>
  );
}
